// extracted by mini-css-extract-plugin
export var dropdownIcon = "_lw-6";
export var imgContainer = "_lw-3";
export var menuIcon = "_lw-5";
export var pillWrapper = "_lw-2";
export var pillsContainer = "_lw-1";
export var subscriptionCard = "_lw-0";
export var subscriptionLogo = "_lw-4";